import { render, staticRenderFns } from "./index.vue?vue&type=template&id=406ea54a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=406ea54a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406ea54a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('406ea54a')) {
      api.createRecord('406ea54a', component.options)
    } else {
      api.reload('406ea54a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=406ea54a&scoped=true", function () {
      api.rerender('406ea54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/components/tab4/index.vue"
export default component.exports